import { render, staticRenderFns } from "./HomeCourseCardDefault.vue?vue&type=template&id=10d9464a&scoped=true"
import script from "./HomeCourseCardDefault.vue?vue&type=script&lang=js"
export * from "./HomeCourseCardDefault.vue?vue&type=script&lang=js"
import style0 from "./HomeCourseCardDefault.vue?vue&type=style&index=0&id=10d9464a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9464a",
  null
  
)

export default component.exports